import { merchantKnowledgeArticleSchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import * as z from "zod";

/**
 * The oldest live article, so the concierge demo shows the same one every
 * time rather than appearing to change what the merchant has written.
 */
export const getDemoKnowledgeArticle = {
  name: "getDemoKnowledgeArticle" as const,
  input: z.object({}),
  output: merchantKnowledgeArticleSchema.nullable(),
};
